import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export const NWG_JOBS_STORE = "nwgJob";

export default {
  namespaced: true,

  state,

  actions,

  getters,

  mutations,
};
